// @flow

export default (): Promise<Object> =>
  new Promise((resolve, reject) => {
    (function waitForGoogleMaps(retries = 0) {
      if (window.google && window.google.maps) {
        resolve(window.google.maps);
        return;
      }
      if (window.MAPS_API_ERROR) {
        reject(new Error(window.MAPS_API_ERROR));
      }
      // retry for 10s
      if (retries > 100) {
        reject(new Error('TIMEOUT'));
      }
      setTimeout(waitForGoogleMaps, 100, retries + 1);
    })();
  });
